import { ResultPagDTO } from "@/interfaces/base-dto";
import { EstadoClinicoDTO, EstadoClinicoFiltroDTO, EstadoClinicoParm } from "@/interfaces/clinic-states";
import { ENDPOINTS } from "@/settings/api-settings";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";

export function listActiveClinicStates(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CLINIC_STATES_ACTIVE)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}


export function getClinicStatesByFilter(
  filtros: EstadoClinicoFiltroDTO,
): Observable<ResultPagDTO<EstadoClinicoDTO>> {
  return from(apiClient.get(ENDPOINTS.CLINIC_STATES, filtros)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function getClinicState(id: number): Observable<EstadoClinicoDTO> {
  return from(apiClient.get(`${ENDPOINTS.CLINIC_STATES}/${id}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function updateClinicState(parm: EstadoClinicoParm): Observable<EstadoClinicoDTO> {
  return from(apiClient.put(`${ENDPOINTS.CLINIC_STATES}`, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
}

export function saveClinicState(parm: EstadoClinicoParm): Observable<EstadoClinicoDTO> {
  if (parm.id) {
    return updateClinicState(parm);
  }
  return from(apiClient.post(`${ENDPOINTS.CLINIC_STATES}`, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : [];
    }),
  );
} 